(()=>{
  window.addEventListener('DOMContentLoaded', () => {
    const mainHeight = document.querySelector('#main').clientHeight;
    const wrapper = document.querySelector('.gradient-bg .gradients-wrapper');
    const container = document.querySelector('.gradient-bg .gradients-container');
    const interBubble = document.querySelector('.gradient-bg .interactive');
    gsap.set(wrapper, {maxHeight: `${mainHeight}px`});

    const posArr = [1,2,3,4,5];
    // shuffle posArr
    for (let i = posArr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [posArr[i], posArr[j]] = [posArr[j], posArr[i]];
    }


    container.querySelectorAll('.g').forEach( g => {
      const pos = posArr.shift();
      g.setAttribute('data-pos', pos);
    })

    // let curX = 0;
    // let curY = 0;
    // let tgX = 0;
    // let tgY = 0;
    // let topY = 0;
    // let isMoving = false;
    // let animationId = null;

    // 성능 최적화: transform3d 사용 + GPU 가속
    // function move() {
    //   const diffX = Math.abs(tgX - curX);
    //   const diffY = Math.abs(tgY - curY);
    //
    //   // 임계값 이하면 애니메이션 중단
    //   if (diffX < 0.1 && diffY < 0.1) {
    //     isMoving = false;
    //     return;
    //   }
    //
    //   curX += (tgX - curX) / 20;
    //   curY += (tgY - curY) / 20;
    //
    //   // GPU 가속을 위한 transform3d 사용
    //   interBubble.style.transform = `translate3d(${Math.round(curX)}px, ${Math.round(curY) + topY}px, 0)`;
    //
    //   animationId = requestAnimationFrame(move);
    // }

    // 쓰로틀링으로 mousemove 이벤트 최적화
    // let lastMoveTime = 0;
    // window.addEventListener('mousemove', (event) => {
    //   const now = Date.now();
    //   if (now - lastMoveTime < 16) return; // 60fps 제한
    //
    //   lastMoveTime = now;
    //   tgX = event.clientX;
    //   tgY = event.clientY;
    //
    //   if (!isMoving) {
    //     isMoving = true;
    //     move();
    //   }
    // });

    // 초기 위치 설정
    // tgX = window.innerWidth / 2;
    // tgY = window.innerHeight / 2;
    // curX = tgX;
    // curY = tgY;

    ScrollTrigger.create({
      trigger: '#main',
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: (self) => {
        const progress = self.progress;
        topY = (wrapper.clientHeight - window.innerHeight) * progress;
        gsap.set(wrapper, { y: topY * -1 });
      }
    });

    // 페이지 숨김 시 애니메이션 정지
    // document.addEventListener('visibilitychange', () => {
    //   if (document.hidden && animationId) {
    //     cancelAnimationFrame(animationId);
    //     isMoving = false;
    //   }
    // });
  })
})();